import publicIp from 'public-ip';
import getFingerprint from './fingerprint';

function initFingerprint() {
    document.querySelectorAll('form > input[name="fingerprint"]').forEach(function (input) {
        getFingerprint({
            hash: true
        }).then(function (fingerprint) {
            input.value = fingerprint;
        })
    });
}

function initFingerprintCreatedAt() {
    document.querySelectorAll('form > input[name="fingerprintCreatedAt"]').forEach(function (input) {
        var fingerprintCreatedAt = localStorage.getItem('anonymous_customer.fingerprintCreatedAt');

        if (null === fingerprintCreatedAt) {
            fingerprintCreatedAt = new Date().toISOString();

            localStorage.setItem('anonymous_customer.fingerprintCreatedAt', fingerprintCreatedAt);
        }

        input.value = fingerprintCreatedAt;
    });
}

function initIP() {
    document.querySelectorAll('form > input[name="ip"]').forEach(function (input) {
        publicIp.v4().then(function (ip) {
            input.value = ip;
        })
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initFingerprint();
    initFingerprintCreatedAt();
    initIP();
})